@if(showModal){
<div class="modal-overlay">
  <div class="modal-content">
    <h1 class="title-h1" style="line-height: 1.3; padding-bottom: 0">
      Contraseña temporal
    </h1>
    <p class="p-g">Por seguridad, debes cambiar tu contraseña temporal</p>

    <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
      <div class="input-cont">
        <div class="input-container">
          <input
            class="input-reservas"
            type="password"
            id="NewPassword"
            placeholder="Nueva contraseña"
            formControlName="NewPassword"
            appPasswordToggle
          />
          <label for="NewPassword" class="input-label">Nueva contraseña</label>
          <img src="./assets/password-g.svg" alt="" />
        </div>
      </div>

      <div class="input-cont">
        <div class="input-container">
          <input
            class="input-reservas"
            type="password"
            id="ConfirmPassword"
            placeholder="Confirmar contraseña"
            formControlName="ConfirmPassword"
            appPasswordToggle
          />
          <label for="ConfirmPassword" class="input-label"
            >Confirmar contraseña</label
          >
          <img src="./assets/password-g.svg" alt="" />
        </div>
      </div>
      <!-- Requisitos de contraseña -->
      <div class="password-requirements">
        @for(requirement of passwordRequirements; track requirement.key) {
        <div class="requirement" [class.met]="requirement.met">
          <i
            class="bi"
            [class.bi-check-circle-fill]="requirement.met"
            [class.bi-circle]="!requirement.met"
          ></i>
          <span>{{ requirement.message }}</span>
        </div>
        }
      </div>

      <button
        class="button-main"
        type="submit"
        [disabled]="!passwordForm.valid || !allRequirementsMet"
      >
        Cambiar contraseña
      </button>
    </form>
  </div>
</div>
}

<!-- Modales -->

@if(isSameNew){
<div class="modal-container">
  <div class="modal-cont">
    <img src="./assets/warning.svg" alt="" />
    <p>No puedes colocar una contraseña utilizada anteriormente</p>
    <button class="btn-m-new" (click)="isSameNew = false">Cerrar</button>
  </div>
</div>
} @if(isSameConfirm){
<div class="modal-container">
  <div class="modal-cont">
    <img src="./assets/warning.svg" alt="" />
    <p>Las contraseñas no coinciden</p>
    <button class="btn-m-new" (click)="isSameConfirm = false">Cerrar</button>
  </div>
</div>
} @if(error){
<div class="modal-container">
  <div class="modal-cont">
    <img src="./assets/warning.svg" alt="" />
    <p>Error al cambiar contraseña</p>
    <button class="btn-m-new" (click)="error = false">Cerrar</button>
  </div>
</div>
}
